<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/" aria-label="Go to home page">
            <i class="fa fa-home"></i>Home
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Statistic</li>
      </ol>
    </nav>

    <div class="card">
      <div class="card-header px-2 py-0">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{ active: activeTab === 'flightTime' }" @click="activeTab = 'flightTime'">
            Flight Time
          </li>
          <li class="nav-item" :class="{ active: activeTab === 'hdo' }" @click="activeTab = 'hdo'">
            HDO
          </li>
        </ul>
      </div>
      <div class="card-body">
        <keep-alive include="FlightReport,HDORecord">
          <FlightReport v-if="activeTab === 'flightTime'" />
          <HDORecord v-if="activeTab === 'hdo'" />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import FlightReport from './FlightReport.vue';
import HDORecord from './HDORecord.vue';

export default {
  name: 'Statistic',
  components: {
    FlightReport,
    HDORecord
  },
  data() {
    return {
      activeTab: 'flightTime'
    };
  },
  created() {
    this.activeTab = 'flightTime';
  }
};
</script>

<style lang="scss" scoped>
.card-header {
  height: 56px;
}

.card {
  min-height: calc(100vh - 153px);
}

.breadcrumb {
  padding: .75rem 1rem;
  margin-bottom: 1rem;
}

.nav-tabs {
  height: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.08) transparent;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}

/* Chrome / Safari 用這個 */
.nav-tabs::-webkit-scrollbar {
  height: 1px;
}

.nav-tabs::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.08) transparent;
  border-radius: 2px;
}

.nav-tabs::-webkit-scrollbar-track {
  background: transparent;
}

.nav-item {
  min-width: 125px;
  height: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: none !important;
  position: relative;
  cursor: pointer;
  &.active {
    font-weight: 500;
    color: #96694c;
  }

  &.active::after {
    content: "";
    display: block;
    width: 100%;
    height: 4px;
    background-color: #96694c;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

/* 手機隱藏 */
@media (max-width: 768px) {
  .nav-tabs {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .nav-tabs::-webkit-scrollbar {
    display: none;
  }
}
</style>
